<template>
	<div>
		<v-row>
			<v-col>
				<login-view v-if="!isConnected" />
			</v-col>
		</v-row>
		<v-row
			v-if="!isAdmin"
			align-content="center"
			justify="center"
		>
			<v-col
				cols="12"
				md="9"
			>
				<news />
			</v-col>
			<v-col
				cols="12"
				md="3"
			>
				<run-news />
			</v-col>
		</v-row>
	</div>
</template>

<script>
import GamesType from "dev/view/home/GamesType";
import News from "./News";
import RunNews from "./RunNews";
import LoginView from "dev/view/auth/LoginView";
import { types } from "src/store/modules/Update.module";

export default {
	name: "Home",
	components: {
		GamesType,
		News,
		LoginView,
		RunNews,
	},
	computed: {
		isConnected () {
			return this.$store.getters.isConnected;
		},
		isAdmin () {
			return this.$store.getters.isAdmin;
		},
	},
	created () {
		this.$store.dispatch(types.FETCH);
	},
};
</script>

<style scoped>
.con {
  margin-top: 40px;
}
</style>
